<template>
  <div>
    <a-card v-if="info">
      <!-- 订单流程 -->
      <div>
        <div class="bold size-18 mb-10">
          订单编号：{{ info.orderNo }}
          <a-tag color="orange">
            {{ info.orderTypeStr }}
          </a-tag>
        </div>
        <div class="mb-10">下单时间：{{ info.createTime }}</div>
        <div class="mb-10">下单人：{{ info.userName }}</div>
        <div class="mb-10" style="color: red" v-if="type == 1">
          <span> 旧件返厂：{{ info.factoryStatus == 1 ? '已开启' : '未开启' }} </span>
          <!-- <span v-if="info.factoryStatus == 1 && info.factoryDataStatus != 1" class="blue ml-20">物流信息未上传</span> -->
        </div>
        <div class="mb-10" style="color: red" v-if="type == 2">
          是否旧件返厂：
          <a-radio-group v-model="factoryStatus" @change="changeFactory" style="margin-left: 10px">
            <a-radio :value="true"> 是 </a-radio>
            <a-radio :value="false"> 否 </a-radio>
          </a-radio-group>
          <!-- <span v-if="info.factoryStatus == 1 && info.factoryDataStatus != 1" class="blue ml-20">物流信息未上传</span> -->
        </div>
        <div class="mb-30 blue size-18 bold">订单来源：{{ info.sourceEnterpriseName }}</div>

        <a-steps :current="currentOrder" v-if="info.orderTimeLine">
          <a-step title="提交订单" :description="info.orderTimeLine.createTime" />
          <a-step title="指派师傅" :description="info.orderTimeLine.acceptTime" />
          <a-step title="预约时间" :description="info.orderTimeLine.reserveTimeBegin" />
          <a-step title="安装完成" :description="info.orderTimeLine.saleTime" />
          <a-step title="验收完成" :description="info.orderTimeLine.orderFinishTime" />
        </a-steps>
      </div>

      <!-- 完工信息 -->
      <div class="mt-30" v-if="currentOrder > 3">
        <div class="title">完工信息</div>
        <div class="plr-20">
          <div v-if="imgs.picList.some((item) => item.infoPath)">
            <div class="bb mtb-15 bold" v-if="info.serialNumber">序列号-扫码：{{ info.serialNumber }}</div>
            <div class="bb mtb-15 bold">完工照片</div>
            <div class="mb-10" v-for="(item, i) in imgs.picList" :key="i + '1'">
              <div v-if="item.infoPath && item.infoPath.length > 0">
                <span class="mr-10">{{ item.infoName }}</span>
                <img class="img mr-10 radius-10" :src="baseUrl + items" alt="" v-for="(items, index) in item.infoPath"
                  :key="index + '2'" @click="previewImg(baseUrl + items)" />
              </div>
            </div>
          </div>
          <div v-if="imgs.videoList.some((item) => item.infoPath)">
            <div class="bb mtb-15 bold">完工视频</div>
            <div class="mb-10" v-for="(item, i) in imgs.videoList" :key="i + '1'">
              <div v-if="item.infoPath && item.infoPath.length > 0">
                <span class="mr-10">{{ item.infoName }}</span>
                <video controls class="video mr-10 radius-10" :src="baseUrl + items" alt=""
                  v-for="(items, index) in item.infoPath" :key="index + '2'" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 客户确认图片 -->
      <div class="mt-30" v-if="info.detectContent">
        <div class="title mb-20"
          v-if="info.detectContent && info.detectContent.resultList && info.detectContent.resultList.length > 0">
          客户确认图片
        </div>
        <a-button v-if="info.detectContent && info.detectContent.resultList && info.detectContent.resultList.length > 0"
          @click="showYanshou(1)" type="primary" class="mr-30">安装前检测单</a-button>
        <a-button
          v-if="info.detectContent && info.detectContent.acceptanceList && info.detectContent.acceptanceList.length > 0"
          @click="showYanshou(2)" type="primary">验收单</a-button>
        <yanshoudan ref="yanshou"></yanshoudan>
      </div>
      <!-- 旧件返厂 -->
      <div class="mt-30" v-if="info.factoryStatus == 1 && info.factoryDataStatus == 1">
        <div class="title">旧件返厂</div>
        <div class="pt-20">
          <div class="mb-20">物流单号：{{ oldReturn.courierNumber }}</div>
          <div class="mb-20">快递公司：{{ oldReturn.courierServicesCompany }}</div>
          <div class="mb-10">
            单号照片：<img v-for="(item, i) in oldReturn.courierImgs" :key="i" class="img mr-10 radius-10"
              :src="baseUrl + item" alt="" @click="previewImg(baseUrl + item)" />
          </div>
          <div class="mb-10" v-if="oldReturn.factoryImgs">
            返厂资料：<img v-for="(item, i) in oldReturn.factoryImgs" :key="i" class="img mr-10 radius-10"
              :src="baseUrl + item" alt="" @click="previewImg(baseUrl + item)" />
          </div>
        </div>
      </div>
      <!-- 基础信息 -->
      <div class="mt-30">
        <div class="title mb-20">基础信息</div>
        <qutable :tableData="jichuData"></qutable>
      </div>
      <!-- 客户信息 -->
      <div class="mt-30">
        <div class="title mb-20">客户信息</div>
        <qutable :tableData="kehuData"></qutable>
      </div>
      <!-- 订单备注 乐橙企业id 29b229bb034511edaf7bfa163e9992db -->
      <div class="mt-30" v-if="info.enterpriseId=='29b229bb034511edaf7bfa163e9992db'&&userType==22">
        <div class="title mb-20">订单备注</div>
        <a-table size="default" ref="table" rowKey="accessoryId" :columns="ordercolumns"
          :dataSource="info.orderRemark" :pagination="false">
        </a-table>
      </div>
      <!-- 物流信息 -->
      <div class="mt-30" v-if="type == 2 || (type == 1 && info.transportList && info.transportList.length > 0)">
        <div class="flex mb-20">
          <div class="title">物流信息</div>
          <a-button type="primary" icon="plus" v-if="type == 2" @click="packageAdd"> 新增物流 </a-button>
        </div>
        <qutable class="mb-10" v-for="(item, i) in info.transportList" :key="i" :tableData="wuliuData[i]"></qutable>
      </div>
      <!-- 配件信息 -->
      <div class="mt-30" v-if="info.needAccessories == 1 && (type == 2 || (type == 1 && info.accessoryList && info.accessoryList.length > 0))
        ">
        <div class="flex mb-20">
          <div class="title">配件信息</div>
          <a-button @click="addPeijian" type="primary" icon="plus" v-if="type == 2"> 新增配件 </a-button>
        </div>
        <qutable class="mb-10" v-for="(item, i) in info.accessoryList" :key="i" :tableData="peijianData[i]"></qutable>
      </div>
      <!-- 金额信息 -->
      <div class="mt-30 money">
        <div class="title mb-20">金额信息</div>
        <table style="width: 100%">
          <tr>
            <td bgcolor="#eef1f6" class="right">
              <p class="mr-15 mb-0">安装金额</p>
            </td>
            <td class="left">
              <p class="ml-15 mb-0">{{ money.originalTotal }}</p>
            </td>
            <td bgcolor="#eef1f6" class="right">
              <p class="mr-15 mb-0">加价金额</p>
            </td>
            <td class="left">
              <p class="ml-15 mb-0">{{ money.modifyPrice }}</p>
            </td>
            <td bgcolor="#eef1f6" class="right">
              <p class="mr-15 mb-0">总计金额</p>
            </td>
            <td class="left">
              <p class="ml-15 mb-0">{{ money.total }}</p>
            </td>
          </tr>
        </table>
      </div>
      <!-- 加价详情 -->
      <div class="mt-30 money" v-if="info.enterprisePrice && info.enterprisePrice.length > 0">
        <div class="title mb-20">加价详情</div>
        <table style="width: 100%" align="center">
          <tr>
            <td bgcolor="#eef1f6">
              <p class="mb-0 center">金额类型</p>
            </td>
            <td bgcolor="#eef1f6">
              <p class="mb-0 center">数量</p>
            </td>
            <td bgcolor="#eef1f6">
              <p class="mb-0 center">订单金额</p>
            </td>
            <td bgcolor="#eef1f6">
              <p class="mb-0 center">提交时间</p>
            </td>
          </tr>
          <tr v-for="(addPrice, index) in info.enterprisePrice" :key="index">
            <td class="left">
              <p class="mb-0 center">{{ addPrice.priceTypeName }}</p>
            </td>
            <td class="left">
              <p class="mb-0 center">{{ addPrice.amount }}</p>
            </td>

            <td class="left">
              <p class="mb-0 center">{{ addPrice.newTotal }}</p>
            </td>

            <td class="left">
              <p class="mb-0 center">{{ addPrice.submitTime }}</p>
            </td>
          </tr>
        </table>
      </div>
      <!-- 备注信息 -->
      <div class="mt-30" v-if="info.masterRemark && info.masterRemark.length > 0 && info.masterRemark[0].remarkInfo">
        <div class="title mb-20">备注信息</div>
        <div class="border">
          <div v-for="(item, i) in info.masterRemark" :key="i">{{ item.remarkInfo }}</div>
        </div>
      </div>
      <!--安装信息-->
      <div class="mt-30" v-if="(info.installCustomize && info.installCustomize.length > 0) ||
        orderClientPic.length > 0 ||
        clientVideo.length > 0
        ">
        <div class="title mb-20">安装信息</div>
        <!--  -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline" :form="form">
            <a-row :gutter="20">
              <a-col :span="6" v-for="(type, index) in info.installCustomize" :key="type.orderInstallId">
                <a-form-item :label="type.infoName" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input v-if="type.infoType == 1" v-model="type.infoValue" disabled />
                  <a-select showSearch :getPopupContainer="getPopupContainer" style="width: 100%" v-model="type.infoValue"
                    optionFilterProp="children" :filterOption="filterOption" :allowClear="true"
                    @change="changeselect(index, $event)" v-if="type.infoType == 3" disabled>
                    <a-select-option v-for="tab in type.dictInfo" :key="tab.dictValue">
                      {{ tab.dictLabel }}</a-select-option>
                  </a-select>
                  <a-select :getPopupContainer="getPopupContainer" style="width: 100%" v-model="type.infoValue"
                    :allowClear="true" v-if="type.infoType == 0" disabled>
                    <a-select-option v-for="tab in type.dictInfo" :key="tab.dictValue">
                      {{ tab.dictLabel }}</a-select-option>
                  </a-select>
                  <a-select :getPopupContainer="getPopupContainer" style="width: 100%" v-model="type.infoValue"
                    :allowClear="true" v-if="type.infoType == 2" disabled>
                    <a-select-option v-for="tab in type.dictInfo" :key="tab.dictValue">
                      {{ tab.dictLabel }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="12" v-if="orderGuideSizePic.length != 0">
                <div>导向片尺寸图片:</div>
                <a-upload :multiple="true" name="file" list-type="picture-card" :file-list="orderGuideSizePic"
                  class="avatar-uploader" :disabled="true" :headers="headers" @preview="handlePreview"
                  :showUploadList="{ showRemoveIcon: false }">
                </a-upload>
              </a-col>
              <a-col :span="12" v-if="orderGuideTypePic.length != 0">
                <div>导向片类型图片:</div>
                <a-upload :multiple="true" name="file" list-type="picture-card" :file-list="orderGuideTypePic"
                  class="avatar-uploader" :disabled="true" :headers="headers" @preview="handlePreview"
                  :showUploadList="{ showRemoveIcon: false }">
                </a-upload>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="24">
                <a-row>
                  <a-col :span="20" style="display: flex">
                    <a-upload :multiple="true" name="file" list-type="picture-card" :file-list="orderClientPic"
                      class="avatar-uploader" :disabled="true" :headers="headers" @preview="handlePreview"
                      :showUploadList="{ showRemoveIcon: false }">
                    </a-upload>
                  </a-col>
                </a-row>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="24">
                <div style="display: flex; flex-direction: row; width: 50%">
                  <div v-for="(item, i) in clientVideo" :key="i" class="mr-10">
                    <video class="video" :key="index" :src="'https://lockan.obs.cn-east-3.myhuaweicloud.com/' + item"
                      controls></video>
                  </div>
                </div>
              </a-col>
            </a-row>
          </a-form>
        </div>
      </div>
      <!-- 关联订单 -->
      <!-- <div class="mt-30" v-if="relationList.length > 0">
        <div class="title mb-20">关联订单</div>
        <a-table
          :loading="editloading"
          size="default"
          ref="table"
          rowKey="orderId"
          :columns="columnsRelation"
          :dataSource="relationList"
          bordered
          :pagination="false"
        >
          <span slot="action" slot-scope="text, record">
            <div v-if="orderType == '2'">
              <a v-if="record.orderLevel != '主订单'" @click="orderMaster(record)">主订单</a>
              <a-divider v-if="record.orderLevel != '主订单'" type="vertical" />
              <a v-else @click="orderMaster(record)">关联</a>
              <a v-if="record.orderLevel != '主订单'" @click="relation(record)">关联</a>
            </div>
            <div v-if="orderType == '1'">
              <a @click="cancelOrderRelation(record)">取消</a>
            </div>
            <div v-if="orderType == '0'">
              <a v-if="record.orderLevel != '子订单'" @click="relation(record)">关联</a>
              <a v-if="record.orderLevel == '子订单'" @click="orderMaster(record)">主订单</a>
              <a-divider v-if="record.orderLevel == '子订单'" type="vertical" />
              <a v-if="record.orderLevel == '子订单'" @click="cancelOrderRelation(record)">取消</a>
            </div>
          </span>
          <span slot="orderNo" slot-scope="text, record">
            <a @click="showassociatedOrder(record.orderId)">{{ record.orderNo }}</a>
          </span>
        </a-table>
      </div> -->
      <!-- 图片预览 -->
      <a-modal :visible="previewVisible" :footer="null" @cancel="previewhandleCancel">
        <img style="width: 100%; padding: 10px" :src="previewImage" />
      </a-modal>
      <!-- 新增物流 -->
      <a-modal v-model="packageable" @ok="addpackage()" title="包裹">
        <a-form :form="formpackage">
          <a-row>
            <a-col>
              <a-form-item style="display: none">
                <a-input v-decorator="['transportId']" />
              </a-form-item>
              <a-form-item label="包裹名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input v-decorator="['transportName', { rules: [{ required: true, message: '请输入包裹名称!' }] }]" />
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="快递公司">
                <a-select v-decorator="['transportCode', { rules: [{ required: true, message: '选择快递公司!' }] }]"
                  :allowClear="true">
                  <a-select-option v-for="type in delivery_company" :key="type.dictValue">{{ type.dictLabel }}
                  </a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="快递单号">
                <a-input v-decorator="['transportNo', { rules: [{ required: true, message: '请输入快递单号!' }] }]" />
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="包裹备注">
                <a-input v-decorator="['remark']" />
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="">
                <!-- <a-checkbox
                  @change="checkboxchange"
                  v-decorator="['isMainbool', { valuePropName: 'checked', initialValue: true }]"
                >
                  重要</a-checkbox
                > -->
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </a-modal>
      <!-- 添加配件-->
      <a-modal v-model="disable" @ok="addAccessories()" @cancel="cancelAccessories" title="配件" :width="950">
        <a-form :form="formaccessories">
          <a-row>
            <a-col :span="12">
              <a-form-item style="display: none">
                <a-input v-decorator="['transportId']" />
              </a-form-item>
              <a-form-item style="display: none">
                <a-input v-decorator="['orderAccessoryId']" />
              </a-form-item>
              <a-form-item v-if="!nameible" label="配件信息" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-select @change="accessoryChange"
                  v-decorator="['accessoryId', { rules: [{ required: true, message: '选择配件信息!' }] }]" :allowClear="true">
                  <a-select-option v-for="type in EnterpriseAccessory" :key="type.accessoryId">
                    {{ type.accessoryName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item v-if="nameible" label="配件信息" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input disabled="disabled"
                  v-decorator="['accessoryName', { rules: [{ required: true, message: '填写配件信息!' }] }]" />
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="配件单价">
                <a-input disabled="disabled"
                  v-decorator="['price', { rules: [{ required: true, message: '填写配件单价!' }] }]" />
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="数量">
                <a-input-number style="width: 100%"
                  v-decorator="['accessoryNum', { rules: [{ required: true, message: '填写数量!' }], initialValue: 1 }]"
                  @change="accessoryNumChange" />
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="配件总金额">
                <a-input disabled="disabled"
                  v-decorator="['totalAmount', { rules: [{ required: true, message: '配件总金额!' }] }]" />
              </a-form-item>
              <a-form-item v-if="!nameible" :labelCol="labelCol" :wrapperCol="wrapperCol" label="发货仓库">
                <a-select v-decorator="['repositoryId', { rules: [{ required: true, message: '选择发货仓库!' }] }]"
                  :allowClear="true">
                  <a-select-option v-for="type in queryEnterpriseStock" :key="type.storeId">
                    {{ type.storeName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item v-if="nameible" label="发货仓库" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input disabled="disabled"
                  v-decorator="['repositoryName', { rules: [{ required: true, message: '填写发货仓库!' }] }]" />
              </a-form-item>
              <a-divider orientation="left"></a-divider>
              <a-checkbox :labelCol="labelCol" :wrapperCol="wrapperCol" :checked="showh" @change="onChangeinfo">物流信息
              </a-checkbox>
            </a-col>
          </a-row>
          <a-row v-if="showh">
            <a-col :span="12">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="发货日期">
                <a-date-picker v-model="time_list" style="width: 100%" @change="onChangeT" format="YYYY-MM-DD" />
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="快递公司">
                <a-select v-decorator="['transportCode', { rules: [{ required: true, message: '选择快递公司!' }] }]"
                  :allowClear="true">
                  <a-select-option v-for="type in delivery_company" :key="type.dictValue">{{ type.dictLabel }}
                  </a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="快递单号">
                <a-input v-decorator="['transportNo', { rules: [{ required: true, message: '选择快递单号!' }] }]" />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="发货人">
                <a-input v-decorator="['sendUser']" />
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="收货人">
                <a-input v-decorator="['receiveUser']" />
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注">
                <a-input v-decorator="['transportRemark']" />
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </a-modal>
      <!-- 回到顶部 -->
      <div>
        <a-back-top :visibilityHeight="200" />
      </div>
    </a-card>
  </div>
</template>

<script>
import qutable from './modules/qutable'
import { getOrderDetail, getOrderMoney, getfinddictAll, updateOrderFactory } from '@/api/order/orderList'
import { getsaleOrderData } from '@/api/order/MasterOrderList'
import { getsearchOrderRelation, getaddTransport, addOrderAccessory } from '@/api/order/editorder'
import {
  getqueryEnterpriseAccessory,
  getqueryEnterpriseAccessoryPrice,
  getqueryEnterpriseStock,
} from '@/api/order/NewlyaddedOrderList'

import yanshoudan from './modules/yanshoudan.vue'
export default {
  data() {
    return {
      orderId: '',
      enterpriseId: this.$store.getters.enterpriseId,
      userType:this.$store.getters.userType,
      type: 1, // type 1 详情  2 编辑
      info: {}, // 详情
      imgs: {}, // 完工照
      oldReturn: {}, // 旧件返厂信息
      money: {}, // 金额信息
      relationList: [], // 关联订单
      orderType: '',
      ordercolumns: [
        {
          title: '',
          align: 'center',
          width: 60,
          customRender: (text, record, index) => `${index + 1}`
        },
        {
          title: '',

          dataIndex: 'action',
          scopedSlots: {
            customRender: 'action'
          },
          width: 150
        },
        {
          title: '',
          dataIndex: 'remarkType',
          width: 60,
          customRender: text => {
            if (text == 1) {
              return '外部'
            } else {
              return '内部'
            }
          }
        },
        {
          title: '',
          dataIndex: 'remarkInfo'
          /* customRender: (text) => text + ' 订单要求' */
        },
        {
          title: '',
          dataIndex: 'updateBy',
          width: 120
        },
        {
          title: '',
          dataIndex: 'updateTime',
          width: 200
        },
        {
          title: '',
          dataIndex: 'appendInfo'
        }
      ],
      columnsRelation: [
        {
          title: '操作栏',
          dataIndex: 'action',
          width: 120,
          scopedSlots: {
            customRender: 'action',
          },
        },
        {
          title: '状态栏',
          dataIndex: 'orderLevel',
          align: 'center',
        },
        {
          title: '订单号',
          dataIndex: 'orderNo',
          scopedSlots: {
            customRender: 'orderNo',
          },
          align: 'center',
        },
        {
          title: '订单类型',
          dataIndex: 'orderTypeName',
          align: 'center',
        },
        {
          title: '订单状态',
          dataIndex: 'status',
          align: 'center',
        },
        {
          title: '企业名称',
          dataIndex: 'enterpriseName',
          align: 'center',
        },
        {
          title: '品牌型号',
          dataIndex: 'brandName',
          align: 'center',
        },
        {
          title: '客户姓名',
          dataIndex: 'clientName',
          align: 'center',
        },
        {
          title: '师傅姓名',
          dataIndex: 'masterName',
          align: 'center',
        },
      ],
      baseUrl: 'https://lockan.obs.cn-east-3.myhuaweicloud.com/',
      jichuData: [],
      kehuData: [],
      wuliuData: [],
      peijianData: [],
      packageable: false, // 添加物流
      formpackage: this.$form.createForm(this),
      delivery_company: [], // 物流公司
      disable: false, // 添加配件
      showh: false, // 物流信息
      formaccessories: this.$form.createForm(this),
      EnterpriseAccessory: [],
      time_list: '',
      parts: {},
      clientVideo: [], // 安装信息
      orderClientPic: [],
      orderGuideSizePic: [], // 导向片尺寸
      orderGuideTypePic: [], //	导向片类型
      previewVisible: false,
      previewImage: '',
      queryEnterpriseStock: [],
      factoryStatus: false,
      masterPrice: 0,
    }
  },
  components: {
    qutable: qutable,
    yanshoudan: yanshoudan,
  },
  computed: {
    currentOrder() {
      if (this.info && this.info.orderTimeLine) {
        const obj = this.info.orderTimeLine
        if (obj && obj.orderFinishTime) {
          return 5
        } else if (obj && obj.saleTime) {
          return 4
        } else if (obj && obj.reserveTimeBegin) {
          return 3
        } else if (obj && obj.acceptTime) {
          return 2
        } else if (obj && obj.createTime) {
          return 1
        } else {
          return 0
        }
      }
    },
  },
  watch: {
    $route(to, from) {
      this.orderId = to.query.orderId
      this.type = to.query.type
      this.init()
    },
  },
  mounted() {
    if (!this.orderId) {
      this.orderId = this.$route.query.orderId
      this.type = this.$route.query.type
      this.init()
    }
  },
  methods: {
    init() {
      this.getOrderInfo()
      getsaleOrderData({
        orderId: this.orderId,
      }).then((res) => {
        this.imgs = res.data
        this.oldReturn = res.data.logisticsInfo || {}
      })
      getOrderMoney({
        orderId: this.orderId,
      }).then((res) => {
        this.money = res.data
      })
      getfinddictAll({
        dictTypes: 'delivery_company',
      }).then((res) => {
        this.delivery_company = res.delivery_company
      })
    },
    getOrderInfo() {
      getOrderDetail({
        orderId: this.orderId,
      }).then((res) => {
        this.info = res.data
        // this.getGuanlian()
        if (res.data) {
          this.factoryStatus = res.data.factoryStatus == 1
          const orderClient = res.data.orderClient
          const orderMaster = res.data.orderMaster || {}
          this.jichuData = [
            {
              lable1: '品牌',
              value1: this.info.brandName,
              lable2: '型号',
              value2: this.info.modelName,
            },
            {
              lable1: '门厚(mm)',
              value1: this.info.doorThickness,
              lable2: '导向片长度(mm)',
              value2: this.info.counterVaneLength,
            },
            {
              lable1: '导向片宽度(mm) ',
              value1: this.info.counterVaneWidth,
              lable2: '是否配件随货',
              value2: this.info.sparepartName,
            },
            {
              lable1: '数量',
              value1: this.info.number,
              lable2: '销单码',
              value2: orderMaster.saleCode,
            },
            {
              lable1: '序列号-商端',
              value1: this.info.serialNumberMerchant,
              lable2: '原始单号',
              value2: this.info.originalOrderNo,
            },
            {
              lable1: '序列号-扫码',
              value1: this.info.serialNumber,
              lable2: '购买渠道',
              value2: this.info.buyChannelName,
            },
            {
              lable1: '消息来源',
              value1: this.info.infoSourceName,
              lable2: '客户下单时间',
              value2: this.info.orderTimeLine.customerOrderTime,
            },
            {
              lable1: 'CTEI码',
              value1: this.info.ctei,
              lable2: '师傅接单时间',
              value2: this.info.orderTimeLine.acceptTime,
            },
            {
              lable1: '订单审核时间',
              value1: this.info.orderTimeLine.applyTime,
              lable2: '配件情况',
              value2: this.info.turnBack,
            },
            {
              lable1: '师傅预约时间',
              value1: this.info.orderTimeLine.appointmentTime,
              lable2: '客户下单',
              value2: this.info.isUserOrder == '1' ? '是' : '否',
            },
            {
              lable1: '订单完成时间',
              value1: this.info.orderTimeLine.orderFinishTime,
              lable2: this.enterpriseId=='29b229bb034511edaf7bfa163e9992db'?'型号':'',
              value2: this.enterpriseId=='29b229bb034511edaf7bfa163e9992db'?this.info.modelName:'',
            },
          ]

          if (this.factoryStatus) {
            this.jichuData.pop()
            this.jichuData.push({
              lable1: '箱码',
              value1: this.info.caseCode,
              lable2: '旧件码',
              value2: this.info.oldPartCode,
            })
            this.jichuData.push({
              lable1: '寄回要求',
              value1: this.info.requirement,
              lable2: '旧件寄回地址',
              value2: this.info.enterpriseAddressName,
            })
          }
          this.kehuData = [
            {
              lable1: '客户姓名',
              value1: orderClient.clientName,
              lable2: '手机号码',
              value2: orderClient.clientPhone,
            },
            {
              lable1: '宽带账号',
              value1: orderClient.broadbandAccount,
              lable2: '电信手机号',
              value2: orderClient.telecomPhone,
            },
            {
              lable1: '客户地址',
              value1: orderClient.fullAdress,
              lable2: '',
              value2: '',
            },
          ]
          const arr = []
          this.info.transportList.forEach((item) => {
            arr.push([
              {
                lable1: '物流公司',
                value1: item.transportCodeName,
                lable2: '物流单号',
                value2: item.transportNo,
              },
              {
                lable1: '预计到货时间',
                value1: item.expectArrivalTime,
                lable2: '',
                value2: '',
              },
            ])
          })
          this.wuliuData = arr
          const arr1 = []
          this.info.accessoryList.forEach((item) => {
            arr1.push([
              {
                lable1: '配件名称',
                value1: item.accessoryName,
                lable2: '物流公司',
                value2: item.transportCode,
              },
              {
                lable1: '配件数量',
                value1: item.accessoryNum,
                lable2: '物流单号',
                value2: item.transportNo,
              },
              {
                lable1: '配件单价',
                value1: item.price,
                lable2: '',
                value2: '',
              },
            ])
          })
          this.peijianData = arr1
          // 安装信息图片、视频
          if (this.info.clientVideo) {
            this.clientVideo = []
            this.info.clientVideo.forEach((pic) => {
              this.clientVideo.push(pic.costmVideoUrl)
            })
          }
          if (this.info.clientPic) {
            const that = this
            that.orderClientPic = []
            this.info.clientPic.forEach((pic) => {
              that.orderClientPic.push({
                uid: pic.costmPicId,
                thumbUrl: 'https://lockan.obs.cn-east-3.myhuaweicloud.com/' + pic.costmPicUrl,
                url: 'https://lockan.obs.cn-east-3.myhuaweicloud.com/' + pic.costmPicUrl,
              })
            })
          }
          if (this.info.guideSizePic) {
            this.orderGuideSizePic = []
            this.info.guideSizePic.map((item, index) => {
              this.orderGuideSizePic.push({
                url: 'https://lockan.obs.cn-east-3.myhuaweicloud.com/' + item,
                uid: index,
              })
            })
          }
          if (this.info.guideTypePic) {
            this.orderGuideTypePic = []
            const arr = this.info.guideTypePic.split(',')
            arr.map((item, index) => {
              this.orderGuideTypePic.push({
                url: 'https://lockan.obs.cn-east-3.myhuaweicloud.com/' + item,
                uid: index,
              })
            })
          }
        }
      })
    },
    // 修改旧件返厂
    changeFactory(e) {
      this.factoryStatus = e.target.value
      updateOrderFactory({
        orderId: this.orderId,
        factoryStatus: this.factoryStatus ? 1 : 0,
      }).then((res) => {
        if (res.code == 0) {
          this.$message.success('设置成功')
          this.getOrderInfo()
        }
      })
    },
    // 验收单弹窗  type 1 安装前  2 验收单
    showYanshou(type) {
      this.$refs.yanshou.init(type, this.info.detectContent)
    },
    // 预览完工图片
    previewImg(file) {
      this.previewImage = file
      this.previewVisible = true
    },
    // 预览安装信息图片
    handlePreview(file) {
      console.log(file)
      if (!file.url && !file.preview) {
        file.preview = file.thumbUrl
      } else {
        file.url = file.url
      }
      this.previewImage = file.url || file.preview
      this.previewVisible = true
    },
    previewhandleCancel() {
      this.previewVisible = false
    },
    getGuanlian() {
      // 关联订单
      getsearchOrderRelation({
        orderId: this.orderId,
        clientAddress: this.info.orderClient.clientAddress,
        clientPhone: this.info.orderClient.clientPhone,
        installType: this.info.installType,
      }).then((res) => {
        console.log(888888888888888)
        if (res.code === 0) {
          this.relationList = res.data.orderList // 关联订单
          this.orderType = res.data.orderType
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 主订单
    orderMaster(record) {
      if (record.orderId == this.orderId22) {
      } else {
        this.orderId22 = record.orderId
        if (this.editloading) {
          return false
        } else {
          this.editloading = true
          addOrderRelation({
            masterOrderId: record.orderId,
            servantOrderId: this.reslist.orderId,
          }).then((res) => {
            if (res.code === 0) {
              this.editloading = false
              getsearchOrderRelation({
                orderId: this.reslist.orderId,
                clientAddress: this.reslist.orderClient.clientAddress,
                clientPhone: this.reslist.orderClient.clientPhone,
                installType: this.reslist.installType,
              }).then((res) => {
                if (res.code === 0) {
                  this.editloading = false
                  this.relationList = res.data.orderList
                  this.orderType = res.data.orderType
                } else {
                  this.editloading = false
                  this.$message.error(res.msg)
                  this.orderId22 = ''
                }
              })
            } else {
              this.editloading = false
              this.$message.error(res.msg)
            }
          })
        }
      }
    },
    // 关联
    relation(record) {
      console.log('record', record)
      if (record.orderId == this.orderId22) {
      } else {
        this.orderId22 = record.orderId
        if (this.editloading) {
          return false
        } else {
          this.editloading = true
          addOrderRelation({
            masterOrderId: this.reslist.orderId,
            servantOrderId: record.orderId,
          }).then((res) => {
            if (res.code === 0) {
              this.editloading = false
              getsearchOrderRelation({
                orderId: this.reslist.orderId,
                clientAddress: this.reslist.orderClient.clientAddress,
                clientPhone: this.reslist.orderClient.clientPhone,
                installType: this.reslist.installType,
              }).then((res) => {
                if (res.code === 0) {
                  this.editloading = false
                  this.relationList = res.data.orderList
                  this.orderType = res.data.orderType
                } else {
                  this.$message.error(res.msg)
                  this.editloading = false
                }
              })
            } else {
              this.$message.error(res.msg)
              this.editloading = false
              this.orderId22 = ''
            }
          })
        }
      }
    },
    ordercancel() {
      this.editOrderible = false
      if (this.backlogNum == 1) {
        this.$emit('Ok')
      } else if (this.backlogNum == 2) {
        this.$emit('ok')
      } else if (this.backlogNum == 3) {
        this.$emit('moneyok')
      } else if (this.backlogNum == 4) {
        this.$emit('ok')
      } else if (this.backlogNum == 5) {
        this.$emit('ok')
      } else if (this.backlogNum == 6) {
        this.$emit('ok')
      }
    },
    // 添加包裹
    packageAdd() {
      if (this.info.transportList.length < 5) {
        this.packageable = true
        this.formpackage.resetFields()
      } else {
        this.$message.error('最多为5条')
      }
    },
    addpackage() {
      this.formpackage.validateFields((err, values) => {
        values.orderId = this.orderId
        values.isMain = values.isMainbool ? '1' : '0'
        if (!err) {
          this.packageable = false
          getaddTransport(values).then((res) => {
            if (res.code === 0) {
              this.getOrderInfo()
            } else {
              this.$message.error(res.msg)
            }
          })
        } else {
          this.$message.error('未填写数据')
        }
      })
    },
    // 新增配件
    addPeijian() {
      console.log(this.formaccessories)
      this.EnterpriseAccessory = []
      this.formaccessories.resetFields()
      this.showh = false
      this.nameible = false
      this.disable = true
      getqueryEnterpriseAccessory({
        brandId: this.info.brandId,
        modelId: this.info.modelId,
        installType: this.info.installType,
        enterpriseId: this.enterpriseId,
      }).then((res) => {
        if (res.code === 0) {
          this.EnterpriseAccessory = res.data
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    addAccessories() {
      this.formaccessories.validateFields((err, values) => {
        values.orderId = this.orderId
        values.deliveryTime = this.parts.deliveryTime
        values.masterPrice = this.masterPrice
        if (!err) {
          this.disable = false
          this.nameible = false
          this.time_list = ''
          addOrderAccessory(values).then((res) => {
            if (res.code === 0) {
              getOrderDetail({
                orderId: this.orderId,
              }).then((res) => {
                if (res.code === 0) {
                  this.getOrderInfo()
                } else {
                  this.$message.error(res.msg)
                }
              })
            } else {
              this.$message.error(res.msg)
            }
          })
        } else {
          this.$message.error('未填写数据')
        }
      })
    },
    /* 配件信息 */
    accessoryChange(e) {
      const accessoryNum =
        this.formaccessories.getFieldValue('accessoryNum') /* 查询企业要求列表 this.queryEnterpriseAccessoryPrice= '' */
      getqueryEnterpriseAccessoryPrice({
        accessoryId: e,
        enterpriseId: this.enterpriseId,
      }).then((res) => {
        if (res.code === 0) {
          if (res.data) {
            if (res.data.price >= 0) {
              this.masterPrice = res.data.masterPrice
              setTimeout(() => {
                this.formaccessories.setFieldsValue({
                  price: res.data.price,
                  masterPrice: res.data.masterPrice,
                })
                this.accessoryNumChange(accessoryNum)
              }, 100)
            }
          }
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 数量更改的时候
    accessoryNumChange(value) {
      const amount = this.formaccessories.getFieldValue('price')
      this.formaccessories.setFieldsValue({
        totalAmount: (amount - 0) * (value - 0),
      })
      if (!this.formaccessories.getFieldValue('orderAccessoryId')) {
        if (this.formaccessories.getFieldValue('accessoryId') && this.enterpriseId && value) {
          /* this.queryEnterpriseStock= []; */
          getqueryEnterpriseStock({
            accessoryId: this.formaccessories.getFieldValue('accessoryId'),
            enterpriseId: this.enterpriseId,
            useNum: value,
          }).then((res) => {
            if (res.code === 0) {
              this.queryEnterpriseStock = res.data.filter((item) => item.storeName)
            } else {
              this.$message.error(res.msg)
            }
          })
        } else {
          this.$message.error('请选择配件，企业名称，配件数量不能为空')
        }
      }

      /* 查询企业可分配仓库 */
    },
    onChangeinfo() {
      this.showh = !this.showh
    },
    onChangeT(date, dateString) {
      this.parts.deliveryTime = dateString
    },
  },
}
</script>
<style lang="less" scoped>
.title {
  font-weight: 700;
  padding-left: 8px;
  border-left: 4px solid #1890ff;
  height: 18px;
  line-height: 18px;
  font-size: 16px;
}

.img {
  width: 90px;
  height: 90px;
}

.video {
  width: 150px;
  height: 150px;
}

.money {

  table,
  table tr th,
  table tr td {
    border: 1px solid #dae6fc;
    line-height: 40px;
  }

  .mb-0 {
    margin-bottom: 0px;
  }

  .mb-0 {
    margin-bottom: 0px;
  }

  .left {
    width: 16.6%;
    color: #999;

    p {
      line-height: 18px !important;
    }
  }

  .right {
    width: 16.6%;
    text-align: right;
  }

  .center {
    text-align: center;
  }
}
</style>
